import { useLocation } from "react-router-dom";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

import VaporOrbs from "./VaporOrbs";
import SmokeWisps from "./SmokeWisps";
import BackgroundPaths from "./BackgroundPaths";
import SparkleField from "./SparkleField";

/**
 * Site-wide top ambient — soft vapor, smoke & paths behind every public page.
 * Home keeps its own rich hero backdrop; all other routes get this layer.
 */
export const PageTopAmbient = () => {
  const { pathname } = useLocation();
  const reduced = usePreferStaticUI();
  const isHome = pathname === "/";

  if (reduced || isHome) return null;

  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-0 z-0 h-[min(54vh,540px)] overflow-hidden"
      aria-hidden="true"
      data-testid="page-top-ambient"
    >
      <VaporOrbs variant="global" />
      <SmokeWisps count={3} subtle />
      <BackgroundPaths
        variant="arc"
        stroke="rgba(74, 63, 107, 0.07)"
        strokeWidth={1}
        className="absolute inset-0 h-full w-full opacity-70"
      />
      <SparkleField count={5} className="opacity-60" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-porcelain" />
    </div>
  );
};

export default PageTopAmbient;
